import 'core-js';
import './dialog';
import './mobile-nav';
import './news-ticker';
import './tabs';
import './back-to-top';

// import function to register Swiper custom elements
import { register } from 'swiper/swiper-element-bundle';

// register Swiper custom elements
register();

// section-fade-in
if (document.querySelector('[data-section-fade-in]')) {
    if ('IntersectionObserver' in window) {
        import(/* webpackChunkName: "section-fade-in" */ './section-fade-in').then();
    }
}

// animate-children
if (document.querySelector('[data-animate-children]')) {
    import(/* webpackChunkName: "animate-children" */ './animate-children').then();
}

// accordion
if (document.querySelector('[data-accordion]')) {
    import(/* webpackChunkName: "accordion" */ './accordion').then();
}

// swiper
if (document.querySelector('swiper-container')) {
    import(/* webpackChunkName: "swiper" */ './swiper').then();
}

// countup
if (document.querySelector('[data-counterup]')) {
    //  IntersectionObserver Polyfill if needed
    if (!('IntersectionObserver' in window)) {
        import(/* webpackChunkName: "intersection-observer" */ 'intersection-observer').then(() => {
            import(/* webpackChunkName: "counterup-helper" */ './counterup-helper').then();
        });
    } else {
        import(/* webpackChunkName: "counterup-helper" */ './counterup-helper').then();
    }
}

// tag-filters
if (document.querySelector('[data-tag-filters]')) {
    import(/* webpackChunkName: "tag-filters" */ './tag-filters').then();
}

// carousel
if (document.querySelector('[data-glide-el]')) {
    import(/* webpackChunkName: "tag-filters" */ './carousel').then();
}
